import SubframeCore from "@subframe/core";

export const SUBSCRIPTION_WARNING_MODAL_DISMISSIBLE = false;

const SUBSCRIPTION_WARNING_MESSAGE =
  "Your subscription is inactive OR you have exceeded the plan limit or you have cancelled the subscription. Your activity and other features may not sync properly. Please contact team@whatsable.app to help you upgrade.";

type SubscriptionWarningModalProps = {
  onClose?: () => void;
};

export default function SubscriptionWarningModal({
  onClose,
}: SubscriptionWarningModalProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
      <div className="relative w-full max-w-lg rounded-xl bg-white px-8 py-10 shadow-lg">
        {SUBSCRIPTION_WARNING_MODAL_DISMISSIBLE && (
          <button
            type="button"
            onClick={onClose}
            className="absolute right-4 top-4 rounded-full p-1 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600"
            aria-label="Close"
          >
            <SubframeCore.Icon name="FeatherX" className="h-5 w-5" />
          </button>
        )}
        <p className="text-center text-sm leading-relaxed text-gray-500">
          {SUBSCRIPTION_WARNING_MESSAGE}
        </p>
      </div>
    </div>
  );
}
